import React from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import OfferPageContainerComponent from './OfferPageContainer/OfferPageContainer.container';

const OfferPage = ({ t, ...props }) => {
    const staticNames = (t && t.offersPage && t.offersPage.offer) || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>

            <section className="wrapper-content offers">
                <OfferPageContainerComponent />
            </section>
        </React.Fragment>
    );
};

OfferPage.propTypes = {
    t: PropTypes.object
};

export default withTranslation(OfferPage);